var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47869 2H33.3082C35.2215 2 36.7869 3.56541 36.7869 5.47869V26.3508C36.7869 28.2641 35.2215 29.8295 33.3082 29.8295H5.47869C3.56541 29.8295 2 28.2641 2 26.3508V5.47869C2 3.56541 3.56541 2 5.47869 2Z",
    stroke: "#C49A36",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7869 5.4787L19.3934 17.6541L2 5.4787",
    stroke: "#C49A36",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.33f067a83149216f9b40b049912dfda5.svg";
export { ForwardRef as ReactComponent };